/**
 * Ryan O'Dowd
 * 2024-02-12
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
  useEffect,
} from 'react';
import CPassage from '@classes/Passage';
import Passage from '@components/Passage';
import {
  View,
} from 'react-native';
import {
  fetchPassage,
} from '@utils/store/actions';
import getStyles from './styles';
import hooks from '@hooks';

// @TODO: needs more bottom padding if height is greater than device height
const Reading = (props: ReadingProps) => {
  const styles = hooks.useStyles(getStyles);
  const dispatch = hooks.useTypedDispatch();

  useEffect(() => {
    dispatch(fetchPassage(props.passage.id));
  }, [props.passage.id, dispatch]);

  return (
    <View style={styles.container}>
      {/* @TODO: option to edit
        - translation
        - book
        - chapter
        - start and end verses
        - make sure it's a valid passage
      */}
      <Passage// @TODO: combine with versememory and Admin/PassagesOfTheDayTable
        passage={props.passage}
        assignmentId={props.id}
        hideActions={true}
        hideSelectionMenu={true}
        hideWrinkleBadges={true}
        hideProgressStyling={true}
        showHeadings={true}
        isExpanded={false}
        isPressDisabled={true}
      />
    </View>
  );
};

class ReadingProps {
  id: number; // @TODO: this is the assignment id, but that's not clear
  passage: CPassage;
};

export default Reading;
